import { createContext, useContext } from 'react'

type ItemAlign = 'center' | 'start'
type ItemSize = 'md' | 'sm'

/** Set by Item for its parts: where the media and actions sit when the description wraps. */
const ItemAlignContext = createContext<ItemAlign>('center')

/** Set by Item.Group for the Items in it, so one list has one density. */
const ItemGroupSizeContext = createContext<ItemSize | undefined>(undefined)

function useItemAlign(): ItemAlign {
  return useContext(ItemAlignContext)
}

function useItemGroupSize(): ItemSize | undefined {
  return useContext(ItemGroupSizeContext)
}

export { ItemAlignContext, ItemGroupSizeContext, useItemAlign, useItemGroupSize }
export type { ItemAlign, ItemSize }
